import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getOverseaAgentPortList(params) {
  return request({
    url: URL.partner.overseaAgentPort,
    method: 'get',
    params
  })
}

export function saveOverseaAgentPort(data) {
  return request({
    url: URL.partner.overseaAgentPort,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delOverseaAgentPort(uuid) {
  return request({
    url: URL.partner.overseaAgentPort + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

export function getOverseaAgentPort(params) {
  return request({
    url: URL.partner.getOverseaAgentPort,
    method: 'get',
    params
  })
}

